import axiosInstance from '~/services/axios-api';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      axiosInstance
    }
  };
});
